



















import { defineComponent, ref, watch } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import BaseList, { BaseListItem } from "@/components/BaseList";
import BaseMenu from "@/components/BaseMenu";
import { getMessageThreadsSortData } from "../config";

export default defineComponent({
  name: "MessageThreadsSort",
  components: { BaseMenu, BaseList, BaseListItem, BaseIconButton },
  props: {
    currentSortItem: { type: Number, required: true },
  },

  setup(props, { emit }) {
    const activeItem = ref(props.currentSortItem);
    const { labels: menuItems } = getMessageThreadsSortData();

    watch(activeItem, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        emit("select", newValue);
      }
    });

    return { menuItems, activeItem };
  },
});
